import moment from 'moment'
import localisationService from '../../../services/localisationService'

const state = {
  token: '',
  logged: false,
  sessionExpirationTime: '',
  customer: {},
  serviceLoading: false,
  countries: [],
  termsAndConditionsDialog: false, // Todo verify utility
  privacyDialog: false,
  infoDialog: false,
  error: undefined
}

const mutations = {
  changeToken (state, newVal) {
    state.token = newVal
  },
  changeLoggedState (state, newVal) {
    state.logged = newVal
  },
  changeSessionExpirationTime (state, newVal) {
    state.sessionExpirationTime = newVal
  },
  changeCustomer (state, newVal) {
    state.customer = newVal
  },
  changeServiceLoadingState (state, newVal) {
    state.serviceLoading = newVal
  },
  changeCountriesList (state, newCountriesList) {
    state.countries = newCountriesList
  },
  changeTermsAndConditionsDialog (state, newState) {
    state.termsAndConditionsDialog = newState
  },
  changeInfoDialog (state, newState) {
    state.infoDialog = newState
  },
  changeError (state, newError) {
    state.error = newError
  }
}

const getters = {
  getToken (state) {
    return state.token
  },
  getCustomer (state) {
    return state.customer
  },
  getSessionExpirationTime (state) {
    return state.sessionExpirationTime
  },
  getCustomerRegistrationNumber (state) {
    return state.customer.registration_number
  },
  loggedIn (state) {
    return state.logged
  },
  getServiceLoadingState (state) {
    return state.serviceLoading
  },
  getCountries (state) {
    return state.countries
  },
  getError (state) {
    return state.error
  },
  activeLoadingStates (state, getters, rootState) {
    let loading = false
    if (rootState.fb.step2Loading || rootState.fb.step3Loading || rootState.fb.step4Loading) {
      loading = true
    }
    return loading
  }
}

const actions = {
  returnHome ({ dispatch, getters }) {
    if (getters.activeLoadingStates) {
      // pass
    } else {
      dispatch('fb/resetStates', null, { root: true })
    }
  },
  async changeToken ({ commit }, token) {
    commit('changeToken', token)
  },
  changeLoggedState ({ commit }, newVal) {
    commit('changeLoggedState', newVal)
  },
  changeError ({ commit }, newVal) {
    commit('changeError', newVal)
  },
  changeSessionExpirationTime ({ commit }, newVal) {
    const expirationTime = moment().add(newVal, 'seconds')
    commit('changeSessionExpirationTime', expirationTime)
  },
  changeServiceLoadingState ({ commit }, newVal) {
    commit('changeServiceLoadingState', newVal)
  },
  async changeCustomer ({ commit }, newValue) {
    commit('changeCustomer', newValue)
  },
  async initCountriesList ({ commit }) {
    const response = await localisationService.getCountries()
    commit('changeCountriesList', response.data)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
